// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Map_wrapper__Z3XHj","opacity":"Map_opacity__jw4qD"};